/* ═══════════════════════════════════════════════════════════
   DG Favorites Page — dg-favorites.js v5
   Always client-side rendered. Uses dgFav API for data + folders.
   v6: Dropdown filters (style collection), active chips, header search.

   Dependencies: dg-favorites-sync.js (window.dgFav)
                 dg.js (refreshCartState, selectCardVariant)
   ═══════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    if (!document.getElementById('dg-fav-grid')) return;

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var gridEl = document.getElementById('dg-fav-grid');
    var emptyEl = document.getElementById('dg-fav-empty');
    var addAllBtn = document.getElementById('dg-fav-add-all');
    var loadingEl = document.getElementById('dg-fav-loading');
    var foldersSlot = document.getElementById('dg-fav-folders-slot');
    var typesSlot = document.getElementById('dg-fav-types-slot');
    var filtersContainer = document.getElementById('dg-fav-inline-filters');
    var activeChipsEl = document.getElementById('dg-fav-active-chips');
    var modalEl = document.getElementById('dg-fav-folder-modal');
    var controlsEl = document.getElementById('dg-fav-controls');
    var countEl = document.getElementById('dg-fav-count');
    var noResultsEl = document.getElementById('dg-fav-no-results');
    var noResultsBodyEl = document.getElementById('dg-fav-no-results-body');
    var histEmptyEl = document.getElementById('dg-fav-hist-empty');
    var resetBtn = document.getElementById('dg-fav-reset-filters');
    var searchInput = document.getElementById('dg-fav-search-input');
    var searchClearBtn = document.getElementById('dg-fav-search-clear');
    var filterBackdrop = null;
    var filterDropdownsBound = false;

    var CHEVRON_SVG = '<svg class="dg-filter-chip__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
    var syncBannerEl = document.getElementById('dg-fav-sync-banner');
    var pageRoot = document.getElementById('dg-favorites-page');
    var loginUrl = (pageRoot && pageRoot.getAttribute('data-login-url')) || '/account/login';

    var activeFolderId = 'all'; // 'all' | folder.id | HIST_ID
    var activeType = 'all';     // 'all' | product type

    /* ── Historique d'achats — la liste AUTO « Déjà commandé » ──────────────
       Ce n'est pas une vraie liste : elle n'existe ni dans dgFav.folders() ni
       côté serveur dans fav_lists. Le POST de la vitrine écrit l'état COMPLET
       des favoris et supprime toute liste absente du payload — une liste auto
       persistée serait donc effacée à la première synchro. Elle est servie par
       sa propre route et rendue à part.

       Le préfixe `__` la met hors d'atteinte des ids de vraies listes (`f_xxxx`). */
    var HIST_ID = '__historique';
    var HIST_LABEL = 'Déjà commandé';
    var HIST_PAGE = 24;         // une entreprise peut avoir 300 SKU : on pagine
    var histData = null;        // payload de dgFav.historique()
    var histShown = 0;          // combien de cartes déjà rendues
    var histSort = 'recence';   // 'recence' | 'frequence' | 'alpha'
    var histLoading = false;

    function isHistMode() { return activeFolderId === HIST_ID; }
    var modalHandle = null;           // product handle when assigning to lists
    var modalMode = 'assign';         // 'assign' | 'create' | 'manage' | 'manage-add'
    var modalManageFolderId = null;   // folder id when managing a list
    var searchQuery = '';
    var searchDebounce = null;
    var batchSearchQuery = '';
    var batchSearchDebounce = null;

    /* ── Toast ─────────────────────────────────────────────── */
    function showToast(msg) {
        var existing = document.getElementById('dg-fav-toast');
        if (existing) existing.remove();

        var toast = document.createElement('div');
        toast.id = 'dg-fav-toast';
        toast.className = 'dg-fav-toast';
        toast.textContent = msg;
        document.body.appendChild(toast);

        void toast.offsetWidth;
        toast.classList.add('is-visible');

        setTimeout(function () {
            toast.classList.remove('is-visible');
            setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
        }, 3000);
    }

    /* ── Cart helpers ──────────────────────────────────────── */
    function addVariantToCart(variantId, qty) {
        return fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
        }).then(function (r) { return r.json(); });
    }

    /* ── Helpers ───────────────────────────────────────────── */
    function escapeHTML(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function getFolderById(id) {
        if (!window.dgFav) return null;
        var fs = window.dgFav.folders();
        for (var i = 0; i < fs.length; i++) if (fs[i].id === id) return fs[i];
        return null;
    }

    function normalizeText(s) {
        return String(s || '').toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function hasActiveFilters() {
        return !!searchQuery || activeFolderId !== 'all' || activeType !== 'all';
    }

    function itemMatchesSearch(item) {
        if (!searchQuery) return true;
        return normalizeText(item.getAttribute('data-search') || '')
            .indexOf(normalizeText(searchQuery)) !== -1;
    }

    function updateSearchClear() {
        if (!searchClearBtn) return;
        var hasQuery = !!(searchInput && searchInput.value.trim());
        searchClearBtn.hidden = !hasQuery;
    }

    function updateCount(total, visible) {
        if (!countEl) return;
        if (total === 0) {
            countEl.hidden = true;
            return;
        }
        countEl.hidden = false;
        if (hasActiveFilters() && visible !== total) {
            countEl.textContent = visible + ' sur ' + total + ' produit' + (total > 1 ? 's' : '');
        } else {
            countEl.textContent = total + ' produit' + (total > 1 ? 's' : '');
        }
    }

    var addAllCartIcon = ''
        + '<svg class="dg-fav-add-all__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>'
        + '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>'
        + '</svg>';

    function getActiveFolder() {
        if (activeFolderId === 'all') return null;
        return getFolderById(activeFolderId);
    }

    function shouldShowAddAll(visibleItems) {
        // « Tout ajouter au panier » sur l'historique, c'est le geste de recommande
        // lui-même — il a plus de sens ici que sur n'importe quelle liste.
        if (isHistMode()) return visibleItems > 0;
        return visibleItems > 0 && activeFolderId !== 'all' && !!getActiveFolder();
    }

    function getAddAllAriaLabel() {
        if (isHistMode()) return 'Ajouter les produits affichés au panier';
        var folder = getActiveFolder();
        if (folder && folder.name) {
            return 'Ajouter la liste ' + folder.name + ' au panier';
        }
        return 'Ajouter la liste au panier';
    }

    function renderAddAllButtonContent() {
        var inner = addAllBtn && addAllBtn.querySelector('.dg-fav-add-all__inner');
        if (!inner) return;

        if (isHistMode()) {
            inner.innerHTML = addAllCartIcon
                + '<span class="dg-fav-add-all__copy">'
                + '<span class="dg-fav-add-all__single">Ajouter ces produits au panier</span>'
                + '</span>';
            return;
        }

        var folder = getActiveFolder();
        if (folder && folder.name) {
            inner.innerHTML = addAllCartIcon
                + '<span class="dg-fav-add-all__copy">'
                + '<span class="dg-fav-add-all__single">Ajouter la liste '
                + escapeHTML(folder.name)
                + ' au panier</span>'
                + '</span>';
            return;
        }

        inner.innerHTML = addAllCartIcon
            + '<span class="dg-fav-add-all__copy">'
            + '<span class="dg-fav-add-all__single">Ajouter la liste au panier</span>'
            + '</span>';
    }

    function updateAddAllLabel() {
        if (!addAllBtn) return;
        if (addAllBtn.disabled) return;
        renderAddAllButtonContent();
        addAllBtn.setAttribute('aria-label', getAddAllAriaLabel());
    }

    function resetFilters() {
        // « Réinitialiser les filtres » est atteignable depuis le mode historique
        // (l'état « aucun résultat »). Remettre activeFolderId à 'all' sans
        // re-rendre laisserait des cartes d'historique dans une grille qui se
        // prétend « Tous les favoris ».
        var etaitHist = isHistMode();
        searchQuery = '';
        activeFolderId = 'all';
        activeType = 'all';
        if (searchInput) searchInput.value = '';
        updateSearchClear();
        closeFavFilterDropdowns();
        buildFolderFilters();
        buildTypeFilters();
        renderActiveChips();
        if (etaitHist) {
            sortirHistorique();
            return;
        }
        applyFilters();
    }

    /* ── Empty state ───────────────────────────────────────── */
    function checkEmpty() {
        var items = gridEl ? gridEl.querySelectorAll('.dg-fav-item') : [];
        var totalItems = items.length;
        var visibleItems = 0;
        items.forEach(function (it) {
            if (it.style.display !== 'none') visibleItems++;
        });

        var noFavoritesAtAll = totalItems === 0;
        var filteredEmpty = totalItems > 0 && visibleItems === 0;
        var hist = isHistMode();

        // Deux vides différents, deux messages différents. Un client peut n'avoir
        // aucun favori ET un historique bien rempli — lui dire « ajoutez des
        // favoris » alors qu'il cherchait ses achats serait un contresens.
        if (emptyEl) emptyEl.style.display = (noFavoritesAtAll && !hist) ? 'flex' : 'none';
        // style.display et non .hidden : .dg-fav-empty pose display:flex, qui bat
        // la règle [hidden] de l'agent utilisateur.
        if (histEmptyEl) histEmptyEl.style.display = (noFavoritesAtAll && hist) ? 'flex' : 'none';
        if (noResultsBodyEl) {
            noResultsBodyEl.textContent = hist
                ? 'Aucun produit de votre historique ne correspond à votre recherche ou à vos filtres.'
                : 'Aucun favori ne correspond à votre recherche ou à vos filtres.';
        }
        if (noResultsEl) noResultsEl.hidden = !filteredEmpty;
        // En mode historique, garder les contrôles visibles même sans résultat :
        // c'est le seul chemin de retour vers « Tous les favoris ».
        if (controlsEl) controlsEl.hidden = noFavoritesAtAll && !hist;
        if (addAllBtn) addAllBtn.hidden = !shouldShowAddAll(visibleItems);

        if (gridEl) {
            gridEl.style.display = (noFavoritesAtAll || filteredEmpty) ? 'none' : '';
        }

        updateCount(totalItems, visibleItems);
        updateSearchClear();
        updateAddAllLabel();
    }

    var activeRemoveConfirmItem = null;

    function closeRemoveConfirm(item) {
        if (!item) return;
        item.classList.remove('is-remove-confirm');
        var confirm = item.querySelector('.dg-fav-item__remove-confirm');
        if (confirm) confirm.hidden = true;
        if (activeRemoveConfirmItem === item) activeRemoveConfirmItem = null;
    }

    function closeAllRemoveConfirms() {
        if (!gridEl) return;
        gridEl.querySelectorAll('.dg-fav-item').forEach(closeRemoveConfirm);
    }

    function showRemoveConfirm(item, productId, handle) {
        if (!item) return;
        closeAllRemoveConfirms();

        var footer = item.querySelector('.dg-fav-item__footer');
        var removeBtn = item.querySelector('.dg-fav-item__remove');
        if (!footer || !removeBtn) return;

        var confirm = item.querySelector('.dg-fav-item__remove-confirm');
        if (!confirm) {
            var confirmId = 'dg-fav-remove-confirm-msg-' + String(productId);

            confirm = document.createElement('div');
            confirm.className = 'dg-fav-item__remove-confirm';
            confirm.hidden = true;
            confirm.setAttribute('role', 'alertdialog');
            confirm.setAttribute('aria-labelledby', confirmId);
            confirm.innerHTML = ''
                + '<p id="' + confirmId + '" class="dg-fav-item__remove-confirm-msg">Retirer des favoris ?</p>'
                + '<div class="dg-fav-item__remove-confirm-actions">'
                + '  <button type="button" class="dg-fav-item__remove-confirm-btn" data-remove-cancel>Non</button>'
                + '  <button type="button" class="dg-fav-item__remove-confirm-btn dg-fav-item__remove-confirm-btn--yes" data-remove-confirm>Oui</button>'
                + '</div>';

            confirm.querySelector('[data-remove-cancel]').addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                closeRemoveConfirm(item);
            });
            confirm.querySelector('[data-remove-confirm]').addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                closeRemoveConfirm(item);
                window.dgFavRemove(productId, handle);
            });

            footer.appendChild(confirm);
        }

        item.classList.add('is-remove-confirm');
        confirm.hidden = false;
        activeRemoveConfirmItem = item;

        var focusBtn = confirm.querySelector('[data-remove-cancel]');
        if (focusBtn) focusBtn.focus();
    }

    function wireRemoveButton(item) {
        var removeBtn = item && item.querySelector('.dg-fav-item__remove');
        if (!removeBtn || removeBtn.getAttribute('data-remove-wired') === '1') return;

        var productId = item.getAttribute('data-product-id');
        var handle = item.getAttribute('data-fav-key');
        if (!productId || !handle) return;

        removeBtn.setAttribute('data-remove-wired', '1');
        removeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            showRemoveConfirm(item, productId, handle);
        });
    }

    /* ══════════════════════════════════════════════════════════
       PUBLIC: dgFavRemove(productId, handle)
       ══════════════════════════════════════════════════════════ */
    window.dgFavRemove = function (productId, handle) {
        var str = String(productId);

        var item = gridEl && gridEl.querySelector('.dg-fav-item[data-product-id="' + str + '"]');
        if (item) {
            item.classList.add('is-removing');
            setTimeout(function () {
                if (item.parentNode) item.remove();
                checkEmpty();
                rebuildFolderFilters();
            }, 290);
        }

        if (handle && typeof window.dgFav !== 'undefined') {
            window.dgFav.remove(handle);
        }

        document.querySelectorAll('.dg-product-card__wishlist[data-product-id="' + str + '"]')
            .forEach(function (btn) { btn.classList.remove('is-wishlisted'); });

        showToast('❤️ Retiré de vos favoris.');
    };

    /* ══════════════════════════════════════════════════════════
       PUBLIC: dgFavAddAll()
       Adds the currently *visible* favorites (respecting active filters).
       ══════════════════════════════════════════════════════════ */
    window.dgFavAddAll = function () {
        if (!gridEl) return;

        // L'historique n'est pas une vraie liste — getActiveFolder() y rend null.
        // Sans ce court-circuit, « Ajouter ces produits au panier » répondrait
        // « Sélectionnez une liste » sur le seul écran où le bouton a le plus de sens.
        if (!isHistMode() && !getActiveFolder()) {
            showToast('Sélectionnez une liste pour ajouter ses produits au panier.');
            return;
        }

        var visibleItems = gridEl.querySelectorAll('.dg-fav-item');
        var variantIds = [];
        visibleItems.forEach(function (item) {
            if (item.style.display === 'none') return;
            var inp = item.querySelector('.dg-product-card__counter-row input[name="id"]');
            if (inp && inp.value) variantIds.push(inp.value);
        });

        if (!variantIds.length) {
            showToast('Aucun produit disponible à ajouter.');
            return;
        }

        if (addAllBtn) {
            addAllBtn.disabled = true;
            addAllBtn.classList.add('is-loading');
            var innerLoad = addAllBtn.querySelector('.dg-fav-add-all__inner');
            if (innerLoad) {
                innerLoad.innerHTML = '<span class="dg-fav-add-all__loading">Ajout en cours…</span>';
            }
        }

        Promise.all(variantIds.map(function (id) {
            return addVariantToCart(id, 1).catch(function () { return null; });
        })).then(function (results) {
            var added = results.filter(Boolean).length;
            if (typeof window.refreshCartState === 'function') window.refreshCartState();
            var folder = getActiveFolder();
            var toastMsg;
            if (folder && folder.name) {
                toastMsg = '🛒 ' + added + ' produit' + (added > 1 ? 's' : '') + ' de la liste « ' + folder.name + ' » ajouté' + (added > 1 ? 's' : '') + ' au panier !';
            } else {
                toastMsg = '🛒 ' + added + ' produit' + (added > 1 ? 's' : '') + ' ajouté' + (added > 1 ? 's' : '') + ' au panier !';
            }
            showToast(toastMsg);
        }).finally(function () {
            if (addAllBtn) {
                addAllBtn.disabled = false;
                addAllBtn.classList.remove('is-loading');
                updateAddAllLabel();
            }
        });
    };

    /* ══════════════════════════════════════════════════════════
       CARD RENDERING
       ══════════════════════════════════════════════════════════ */
    var FETCH_CONCURRENCY = 5;

    // Outcomes MUST stay distinguishable. A 404 is a fact (the product is gone); a
    // 429, a 5xx or a dropped connection are accidents. Collapsing both into `null`
    // is what let pruneStaleFavoriteHandles delete perfectly valid favorites — on the
    // server too — from a single throttled response.
    // → { status: 'ok', html } | { status: 'gone' } | { status: 'error', retryAfter }
    /**
     * A favorite is an item key, not a handle. Resolve it to the product URL plus
     * the exact variant so a Caisse comes back as a Caisse.
     */
    function urlPourCle(key) {
        var info = window.dgFav && window.dgFav.keyInfo
            ? window.dgFav.keyInfo(key)
            : { handle: key, variantId: null };
        if (!info || !info.handle) return null;
        var url = ROOT + 'products/' + info.handle + '?section_id=dg-ajax-favorite-card';
        if (info.variantId) url += '&variant=' + encodeURIComponent(info.variantId);
        return url;
    }

    function fetchProductHTML(key) {
        var url = urlPourCle(key);
        // No handle known (a 'v:' key whose meta was lost): can't render it, but it
        // is NOT gone — never let this become a deletion signal.
        if (!url) return Promise.resolve({ status: 'error' });
        return fetch(url)
            .then(function (r) {
                if (r.status === 404) return { status: 'gone' };
                if (!r.ok) {
                    var ra = parseInt(r.headers.get('Retry-After') || '', 10);
                    return { status: 'error', retryAfter: isFinite(ra) ? ra : 0 };
                }
                return r.text().then(function (html) {
                    var div = document.createElement('div');
                    div.innerHTML = html;
                    var item = div.querySelector('.dg-fav-item');
                    // Rendered but no card: ambiguous (section renamed, product hidden
                    // from the channel). Never a deletion signal.
                    return item ? { status: 'ok', html: item.outerHTML } : { status: 'error' };
                });
            })
            .catch(function () { return { status: 'error' }; });
    }

    function fetchProductHTMLWithRetry(handle) {
        return fetchProductHTML(handle).then(function (res) {
            if (res.status !== 'error') return res;
            var wait = Math.min((res.retryAfter || 0) * 1000 || 600, 5000);
            return new Promise(function (resolve) { setTimeout(resolve, wait); })
                .then(function () { return fetchProductHTML(handle); });
        });
    }

    // Firing one request per favorite all at once is what produced the 429s that were
    // then read as deletions — the bigger the list, the harder it self-inflicted.
    function pool(items, limit, worker) {
        var results = new Array(items.length);
        var next = 0;
        function run() {
            if (next >= items.length) return Promise.resolve();
            var i = next++;
            return worker(items[i]).then(function (r) {
                results[i] = r;
                return run();
            });
        }
        var runners = [];
        for (var i = 0; i < Math.min(limit, items.length); i++) runners.push(run());
        return Promise.all(runners).then(function () { return results; });
    }

    /* ══════════════════════════════════════════════════════════
       PER-CARD ENRICHMENT (folder chips + Ranger button + data attrs)
       ══════════════════════════════════════════════════════════ */
    function enrichCard(item) {
        if (!item || !window.dgFav) return;
        var handle = item.getAttribute('data-fav-key');
        if (!handle) return;

        // ── Historique : liste AUTO, en lecture seule ──────────────────────────
        // Une carte d'historique n'est pas un favori. Ni pastilles de liste (elle
        // n'appartient à aucune), ni « Retirer des favoris » (il n'y a rien à
        // retirer), ni bouton « Liste » (ranger un non-favori dans une liste
        // créerait une appartenance orpheline). Le seul geste offert est le CŒUR
        // de la carte produit, qui en fait un vrai favori — c'est exactement le
        // « copier vers une vraie liste » demandé.
        if (isHistMode()) {
            item.setAttribute('data-folders', '');
            var rm = item.querySelector('.dg-fav-item__remove');
            if (rm) rm.remove();
            return;
        }

        var folderIds = window.dgFav.foldersOf(handle);
        item.setAttribute('data-folders', folderIds.join(','));

        var allFolders = window.dgFav.folders();
        var folderMap = {};
        for (var i = 0; i < allFolders.length; i++) folderMap[allFolders[i].id] = allFolders[i];

        var card = item.querySelector('.dg-product-card');
        if (card && !item.querySelector('.dg-fav-item__chips')) {
            var chips = document.createElement('div');
            chips.className = 'dg-fav-item__chips';
            item.insertBefore(chips, card);
        }
        var chipsEl = item.querySelector('.dg-fav-item__chips');
        if (chipsEl) {
            var chipsHTML = '';
            for (var j = 0; j < folderIds.length; j++) {
                var f = folderMap[folderIds[j]];
                if (!f) continue;
                chipsHTML += '<span class="dg-fav-folder-chip dg-fav-color-' + escapeHTML(f.color) + '" title="Dans la liste : ' + escapeHTML(f.name) + '">'
                    + '<span class="dg-fav-folder-chip__dot"></span>'
                    + '<span class="dg-fav-folder-chip__name">' + escapeHTML(f.name) + '</span>'
                    + '</span>';
            }
            chipsEl.innerHTML = chipsHTML;
        }

        var folderNames = [];
        for (var k = 0; k < folderIds.length; k++) {
            var ff = folderMap[folderIds[k]];
            if (ff) folderNames.push(ff.name);
        }
        var baseSearch = item.getAttribute('data-search') || '';
        item.setAttribute('data-search', normalizeText(baseSearch + ' ' + folderNames.join(' ')));

        var removeBtn = item.querySelector('.dg-fav-item__remove');
        var footer = item.querySelector('.dg-fav-item__footer');
        if (removeBtn && !footer) {
            footer = document.createElement('div');
            footer.className = 'dg-fav-item__footer';
            removeBtn.parentNode.insertBefore(footer, removeBtn);
            footer.appendChild(removeBtn);
        }

        wireRemoveButton(item);

        var assignBtn = item.querySelector('.dg-fav-item__assign');
        var mediaEl = card && card.querySelector('.dg-product-card__media');
        var assignHost = mediaEl || card;

        if (assignHost) {
            if (!assignBtn) {
                assignBtn = document.createElement('button');
                assignBtn.type = 'button';
                assignBtn.className = 'dg-fav-item__assign';
                assignBtn.setAttribute('aria-label', 'Ajouter à une liste');
                assignBtn.innerHTML = ''
                    + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
                    + '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>'
                    + '</svg>'
                    + '<span>Liste</span>';
                assignBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openFolderModal(handle);
                });
            }
            if (!assignHost.contains(assignBtn)) {
                assignHost.insertBefore(assignBtn, assignHost.firstChild);
            }
            if (footer && footer.contains(assignBtn)) {
                footer.removeChild(assignBtn);
            }
        }
    }

    function enrichAllCards() {
        if (!gridEl) return;
        var items = gridEl.querySelectorAll('.dg-fav-item');
        items.forEach(enrichCard);
    }

    /* ══════════════════════════════════════════════════════════
       FILTERS — combined (folder ∧ type ∧ search)
       ══════════════════════════════════════════════════════════ */
    function applyFilters() {
        if (!gridEl) return;
        var items = gridEl.querySelectorAll('.dg-fav-item');
        items.forEach(function (item) {
            var card = item.querySelector('.dg-product-card');
            var cType = card ? (card.getAttribute('data-product-type') || '') : '';
            var folders = (item.getAttribute('data-folders') || '').split(',').filter(Boolean);

            var matchType = activeType === 'all' || cType === activeType;
            // En mode historique la grille NE contient que de l'historique : le
            // filtre par liste n'a rien à trancher. Sans ce court-circuit, aucune
            // carte ne passerait (aucune n'appartient à la liste `__historique`).
            var matchFolder = activeFolderId === 'all' || isHistMode()
                || folders.indexOf(activeFolderId) !== -1;
            var matchSearch = itemMatchesSearch(item);

            item.style.display = (matchType && matchFolder && matchSearch) ? '' : 'none';
        });
        renderActiveChips();
        checkEmpty();
    }

    function isMobileFilters() {
        return window.innerWidth <= 767;
    }

    function showFilterBackdrop() {
        if (filterBackdrop) return;
        filterBackdrop = document.createElement('div');
        filterBackdrop.className = 'dg-filter-backdrop';
        var host = pageRoot || document.body;
        host.appendChild(filterBackdrop);
        filterBackdrop.addEventListener('click', closeFavFilterDropdowns);
        if (isMobileFilters()) document.body.classList.add('dg-modal-open');
    }

    function hideFilterBackdrop() {
        if (filterBackdrop) {
            filterBackdrop.remove();
            filterBackdrop = null;
        }
        if (!modalEl || modalEl.hidden) {
            document.body.classList.remove('dg-modal-open');
        }
    }

    function closeFavFilterDropdowns() {
        if (!filtersContainer) return;
        filtersContainer.querySelectorAll('.dg-filter-dropdown').forEach(function (d) {
            var popover = d.querySelector('.dg-filter-popover');
            var chip = d.querySelector('.dg-filter-chip');
            if (popover) {
                popover.hidden = true;
                popover.style.left = '';
                popover.style.right = '';
            }
            if (chip) chip.setAttribute('aria-expanded', 'false');
            d.classList.remove('is-open');
        });
        hideFilterBackdrop();
    }

    function toggleFilterDropdown(dropdown) {
        if (!dropdown) return;
        var chip = dropdown.querySelector('.dg-filter-chip');
        var popover = dropdown.querySelector('.dg-filter-popover');
        if (!chip || !popover) return;

        var wasOpen = !popover.hidden;
        closeFavFilterDropdowns();

        if (!wasOpen) {
            popover.hidden = false;
            chip.setAttribute('aria-expanded', 'true');
            dropdown.classList.add('is-open');
            showFilterBackdrop();

            if (!isMobileFilters()) {
                requestAnimationFrame(function () {
                    var rect = popover.getBoundingClientRect();
                    if (rect.right > window.innerWidth - 8) {
                        popover.style.left = 'auto';
                        popover.style.right = '0';
                    }
                });
            }
        }
    }

    function initFavFilterDropdowns() {
        if (!filtersContainer || filterDropdownsBound) return;
        filterDropdownsBound = true;

        filtersContainer.addEventListener('click', function (e) {
            var chip = e.target.closest('.dg-filter-chip');
            if (chip) {
                e.stopPropagation();
                toggleFilterDropdown(chip.closest('.dg-filter-dropdown'));
                return;
            }

            var editBtn = e.target.closest('[data-folder-edit]');
            if (editBtn) {
                e.preventDefault();
                e.stopPropagation();
                closeFavFilterDropdowns();
                openFolderEditMenu(editBtn.getAttribute('data-folder-edit'));
                return;
            }

            var createBtn = e.target.closest('[data-folder-action="create"]');
            if (createBtn) {
                e.preventDefault();
                e.stopPropagation();
                closeFavFilterDropdowns();
                promptCreateFolder();
                return;
            }

            var folderOpt = e.target.closest('[data-folder-id]');
            if (folderOpt && folderOpt.classList.contains('dg-fav-filter-option')) {
                e.preventDefault();
                var avant = activeFolderId;
                activeFolderId = folderOpt.getAttribute('data-folder-id') || 'all';
                closeFavFilterDropdowns();

                // L'historique n'est pas un filtre sur les cartes déjà rendues : la
                // grille contient les FAVORIS. Entrer ou sortir du mode change la
                // source de la grille, donc il faut re-rendre, pas re-filtrer.
                if (isHistMode()) {
                    buildFolderFilters();
                    renderActiveChips();
                    renderHistorique(false);
                    return;
                }
                if (avant === HIST_ID) {
                    buildFolderFilters();
                    renderActiveChips();
                    sortirHistorique();
                    return;
                }

                buildFolderFilters();
                renderActiveChips();
                applyFilters();
                return;
            }

            var sortOpt = e.target.closest('[data-hist-sort]');
            if (sortOpt) {
                e.preventDefault();
                histSort = sortOpt.getAttribute('data-hist-sort') || 'recence';
                closeFavFilterDropdowns();
                // Le tri change l'ORDRE de la liste entière, pas seulement des cartes
                // visibles : une entreprise à 300 SKU verrait sinon un tri qui ne
                // porte que sur les 24 premières. On repart de zéro.
                renderHistorique(false);
                return;
            }

            var typeOpt = e.target.closest('[data-type-filter]');
            if (typeOpt && typeOpt.classList.contains('dg-fav-filter-option')) {
                e.preventDefault();
                activeType = typeOpt.getAttribute('data-type-filter') || 'all';
                closeFavFilterDropdowns();
                buildTypeFilters();
                renderActiveChips();
                applyFilters();
            }
        });

        filtersContainer.addEventListener('click', function (e) {
            var popover = e.target.closest('.dg-filter-popover');
            if (popover) e.stopPropagation();
        });

        document.addEventListener('click', function (e) {
            if (filtersContainer && filtersContainer.contains(e.target)) return;
            closeFavFilterDropdowns();
        });
    }

    function renderActiveChips() {
        if (!activeChipsEl) return;
        var chips = [];

        if (searchQuery) {
            chips.push({
                key: 'search',
                label: 'Recherche : « ' + searchQuery + ' »'
            });
        }

        if (activeFolderId !== 'all') {
            var folder = getFolderById(activeFolderId);
            if (folder) {
                chips.push({
                    key: 'folder',
                    label: 'Liste : ' + folder.name
                });
            }
        }

        if (activeType !== 'all') {
            chips.push({
                key: 'type',
                label: 'Catégorie : ' + activeType
            });
        }

        if (!chips.length) {
            activeChipsEl.hidden = true;
            activeChipsEl.innerHTML = '';
            return;
        }

        var html = '';
        chips.forEach(function (c) {
            html += '<button type="button" class="dg-fav-active-chip" data-clear-filter="' + escapeHTML(c.key) + '">'
                + '<span>' + escapeHTML(c.label) + '</span>'
                + '<span class="dg-fav-active-chip__x" aria-hidden="true">×</span>'
                + '</button>';
        });
        activeChipsEl.innerHTML = html;
        activeChipsEl.hidden = false;

        activeChipsEl.querySelectorAll('[data-clear-filter]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var key = this.getAttribute('data-clear-filter');
                if (key === 'search') {
                    searchQuery = '';
                    if (searchInput) searchInput.value = '';
                    updateSearchClear();
                } else if (key === 'folder') {
                    activeFolderId = 'all';
                    buildFolderFilters();
                } else if (key === 'type') {
                    activeType = 'all';
                    buildTypeFilters();
                }
                renderActiveChips();
                applyFilters();
            });
        });
    }

    function buildFilterDropdownMarkup(chipLabel, chipActive, menuHtml) {
        return ''
            + '<div class="dg-filter-dropdown">'
            + '<button type="button" class="dg-filter-chip' + (chipActive ? ' is-active' : '') + '" aria-haspopup="true" aria-expanded="false">'
            + '<span class="dg-filter-chip__label">' + escapeHTML(chipLabel) + '</span>'
            + CHEVRON_SVG
            + '</button>'
            + '<div class="dg-filter-popover" hidden>'
            + '<div class="dg-fav-filter-menu">' + menuHtml + '</div>'
            + '</div>'
            + '</div>';
    }

    function buildTypeFilters() {
        if (!typesSlot || !gridEl) return;

        var items = gridEl.querySelectorAll('.dg-fav-item');
        var types = new Set();
        items.forEach(function (item) {
            var card = item.querySelector('.dg-product-card');
            var type = card ? card.getAttribute('data-product-type') : '';
            if (type && type.trim() !== '') types.add(type.trim());
        });

        if (types.size < 2) {
            typesSlot.hidden = true;
            typesSlot.innerHTML = '';
            activeType = 'all';
            renderActiveChips();
            return;
        }

        if (activeType !== 'all' && !types.has(activeType)) activeType = 'all';

        var sortedTypes = Array.from(types).sort();
        var menu = '';
        menu += '<button type="button" class="dg-fav-filter-option' + (activeType === 'all' ? ' is-active' : '') + '" data-type-filter="all">'
            + '<span class="dg-fav-filter-option__name">Toutes les catégories</span></button>';
        sortedTypes.forEach(function (t) {
            menu += '<button type="button" class="dg-fav-filter-option' + (activeType === t ? ' is-active' : '') + '" data-type-filter="' + escapeHTML(t) + '">'
                + '<span class="dg-fav-filter-option__name">' + escapeHTML(t) + '</span></button>';
        });

        var chipLabel = activeType === 'all' ? 'Catégorie' : activeType;
        typesSlot.innerHTML = buildFilterDropdownMarkup(chipLabel, activeType !== 'all', menu);
        typesSlot.hidden = false;
        renderActiveChips();
    }

    function buildFolderFilters() {
        if (!foldersSlot || !window.dgFav) return;

        var folders = window.dgFav.folders();
        var hasAnyFavorites = window.dgFav.list().length > 0;
        var hasHistorique = !!(histData && histData.items && histData.items.length);

        // Un client sans aucun favori peut très bien avoir un historique : c'est
        // même le cas le plus intéressant, celui qui n'a jamais épinglé un produit.
        // Ne masquer le sélecteur que s'il n'y a NI l'un NI l'autre.
        if (!hasAnyFavorites && !hasHistorique) {
            foldersSlot.hidden = true;
            foldersSlot.innerHTML = '';
            return;
        }

        if (activeFolderId !== 'all' && !isHistMode() && !getFolderById(activeFolderId)) {
            activeFolderId = 'all';
        }

        var menu = '';
        menu += '<button type="button" class="dg-fav-filter-option' + (activeFolderId === 'all' ? ' is-active' : '') + '" data-folder-id="all">'
            + '<span class="dg-fav-filter-option__dot"></span>'
            + '<span class="dg-fav-filter-option__name">Tous les favoris</span></button>';

        if (hasHistorique) {
            var nHist = histData.items.length;
            menu += '<button type="button" class="dg-fav-filter-option dg-fav-filter-option--auto' + (isHistMode() ? ' is-active' : '') + '" data-folder-id="' + HIST_ID + '">'
                + '<span class="dg-fav-filter-option__dot dg-fav-color-teal"></span>'
                + '<span class="dg-fav-filter-option__name">' + escapeHTML(HIST_LABEL) + '</span>'
                + '<span class="dg-fav-filter-option__meta">' + nHist + ' produit' + (nHist > 1 ? 's' : '') + '</span>'
                + '</button>';
            if (folders.length > 0) menu += '<div class="dg-fav-filter-divider"></div>';
        }

        for (var i = 0; i < folders.length; i++) {
            var f = folders[i];
            var count = f.handles.length;
            var countLabel = count === 1 ? '1 produit' : count + ' produits';
            menu += '<div class="dg-fav-filter-row">'
                + '<button type="button" class="dg-fav-filter-option' + (activeFolderId === f.id ? ' is-active' : '') + '" data-folder-id="' + escapeHTML(f.id) + '">'
                + '<span class="dg-fav-filter-option__dot"></span>'
                + '<span class="dg-fav-filter-option__name">' + escapeHTML(f.name) + '</span>'
                + '<span class="dg-fav-filter-option__meta">' + countLabel + '</span>'
                + '</button>'
                + '<button type="button" class="dg-fav-filter-option__edit" data-folder-edit="' + escapeHTML(f.id) + '" aria-label="Modifier la liste ' + escapeHTML(f.name) + '">Modifier</button>'
                + '</div>';
        }

        if (folders.length > 0) menu += '<div class="dg-fav-filter-divider"></div>';
        menu += '<button type="button" class="dg-fav-filter-option dg-fav-filter-option--action" data-folder-action="create">+ Nouvelle liste</button>';

        var chipLabel = 'Mes listes';
        var activeFolder = getActiveFolder();
        if (isHistMode()) chipLabel = HIST_LABEL;
        else if (activeFolder && activeFolder.name) chipLabel = activeFolder.name;

        foldersSlot.innerHTML = buildFilterDropdownMarkup(chipLabel, activeFolderId !== 'all', menu);
        foldersSlot.hidden = false;
        renderActiveChips();
    }

    function rebuildFolderFilters() {
        buildFolderFilters();
        enrichAllCards();
        applyFilters();
    }

    /* ══════════════════════════════════════════════════════════
       FOLDER CREATE / RENAME / DELETE / COLOR — bottom sheet UX
       ══════════════════════════════════════════════════════════ */
    var MODAL_CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

    function formatProductCount(n) {
        if (n === 0) return 'Aucun produit';
        if (n === 1) return '1 produit';
        return n + ' produits';
    }

    /** Handles dont la carte produit a été chargée avec succès sur la page. */
    function getLoadedFavoriteHandlesSet() {
        var set = {};
        if (!gridEl) return set;
        gridEl.querySelectorAll('.dg-fav-item[data-fav-key]').forEach(function (el) {
            var h = el.getAttribute('data-fav-key');
            if (h) set[h] = true;
        });
        return set;
    }

    var PRUNE_MAX_RATIO = 0.3;

    function pruneStaleFavoriteHandles(handles, results) {
        if (!window.dgFav || !window.dgFav.pruneHandles || !handles.length) return 0;
        // ⚠️ GARDE-FOU. Cette fonction SUPPRIME des favoris, côté serveur y compris.
        // Les clés de l'historique ne sont pas des favoris : les lui passer
        // effacerait la collection du client au premier produit retiré du catalogue.
        // renderHistorique ne l'appelle pas ; ceci est la seconde barrière.
        if (isHistMode()) {
            console.warn('[dg-favorites] pruneStaleFavoriteHandles ignoré en mode historique.');
            return 0;
        }
        var stale = [];
        for (var i = 0; i < handles.length; i++) {
            if (results[i] && results[i].status === 'gone') stale.push(handles[i]);
        }
        if (!stale.length) return 0;

        // A renamed section or a Shopify incident makes every handle look "gone".
        // Wiping a whole account on that signal is not recoverable, so refuse instead.
        if (stale.length > handles.length * PRUNE_MAX_RATIO) {
            console.warn('[dg-favorites] ' + stale.length + '/' + handles.length +
                ' favoris introuvables — retrait annulé (seuil de sécurité).');
            showToast('Certains favoris n’ont pas pu être chargés. Rien n’a été retiré.');
            return 0;
        }

        var n = window.dgFav.pruneHandles(stale);
        if (n > 0) {
            console.debug('[dg-favorites] Retiré', n, 'favori(s) introuvable(s) du catalogue.');
        }
        return n;
    }

    function getProductPreview(handle) {
        var out = { title: '', imgSrc: '', imgAlt: '' };
        if (!handle || !gridEl) return out;
        var item = gridEl.querySelector('.dg-fav-item[data-fav-key="' + cssEscape(handle) + '"]');
        if (!item) return out;
        var img = item.querySelector('.dg-product-card__img:not(.dg-product-card__img--hover):not(.dg-product-card__img--placeholder)');
        var titleEl = item.querySelector('.dg-product-card__title');
        if (img) {
            out.imgSrc = img.getAttribute('src') || '';
            out.imgAlt = img.getAttribute('alt') || '';
        }
        if (titleEl) out.title = (titleEl.textContent || '').trim();
        return out;
    }

    function buildSwatchHTML(palette, activeColor, dataAttr) {
        var html = '';
        var attr = dataAttr || 'data-new-color';
        for (var p = 0; p < palette.length; p++) {
            var c = palette[p];
            html += '<button type="button" class="dg-fav-color-swatch dg-fav-color-' + escapeHTML(c)
                + (c === activeColor ? ' is-active' : '') + '" ' + attr + '="' + escapeHTML(c)
                + '" aria-label="Couleur ' + escapeHTML(c) + '"></button>';
        }
        return html;
    }

    function promptCreateFolder() {
        openFolderModalCreate();
    }

    function openFolderEditMenu(folderId) {
        openFolderManageModal(folderId);
    }

    function showModal() {
        if (!modalEl) return;
        modalEl.hidden = false;
        modalEl.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dg-modal-open');
    }

    function openFolderModal(handle) {
        if (!modalEl || !window.dgFav || !handle) return;
        modalMode = 'assign';
        modalHandle = handle;
        modalManageFolderId = null;
        renderModal();
        showModal();
    }

    function openFolderModalCreate() {
        if (!modalEl || !window.dgFav) return;
        modalMode = 'create';
        modalHandle = null;
        modalManageFolderId = null;
        renderModal({ expandCreate: true });
        showModal();
    }

    function openFolderManageModal(folderId) {
        if (!modalEl || !window.dgFav || !folderId) return;
        var folder = getFolderById(folderId);
        if (!folder) return;
        modalMode = 'manage';
        modalHandle = null;
        modalManageFolderId = folderId;
        renderModal();
        showModal();
    }

    function openManageAddProducts() {
        if (modalMode !== 'manage' || !modalManageFolderId) return;
        saveManageFolderName();
        batchSearchQuery = '';
        modalMode = 'manage-add';
        renderModal();
    }

    function backToManageFromAdd() {
        if (modalMode !== 'manage-add' || !modalManageFolderId) return;
        modalMode = 'manage';
        renderModal();
    }

    function closeFolderModal() {
        if (!modalEl) return;
        modalEl.hidden = true;
        modalEl.setAttribute('aria-hidden', 'true');
        modalHandle = null;
        modalMode = 'assign';
        modalManageFolderId = null;
        document.body.classList.remove('dg-modal-open');
    }

    function buildCreateBlockHTML(swatchHTML, expandBody, hideToggle) {
        var collapsed = expandBody ? '' : ' is-collapsed';
        var toggleHTML = hideToggle ? '' : (
            '  <button type="button" class="dg-fav-folder-create__toggle" data-create-toggle aria-expanded="' + (expandBody ? 'true' : 'false') + '">'
            + '    <span class="dg-fav-folder-create__toggle-icon" aria-hidden="true">+</span> Créer une nouvelle liste'
            + '  </button>'
        );
        return ''
            + '<div class="dg-fav-folder-create' + collapsed + '" id="dg-fav-folder-create">'
            + toggleHTML
            + '  <div class="dg-fav-folder-create__body"' + (expandBody ? '' : ' hidden') + '>'
            + '    <label class="dg-fav-folder-create__label" for="dg-fav-new-folder-name">Nom de la liste</label>'
            + '    <div class="dg-fav-folder-create__row">'
            + '      <input type="text" id="dg-fav-new-folder-name" maxlength="40" placeholder="Ex. Pizzas, Mexicain…" autocomplete="off">'
            + '      <button type="button" class="dg-btn dg-btn--primary" id="dg-fav-create-and-assign">Créer et ajouter</button>'
            + '    </div>'
            + '    <button type="button" class="dg-fav-folder-create__color-toggle" data-color-toggle aria-expanded="false">Personnaliser la couleur</button>'
            + '    <div class="dg-fav-color-swatches" data-color-panel hidden>' + swatchHTML + '</div>'
            + '  </div>'
            + '</div>';
    }

    function wireModalClose() {
        modalEl.querySelectorAll('[data-modal-close]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                if (modalMode === 'manage' || modalMode === 'manage-add') saveManageFolderName();
                closeFolderModal();
            });
        });
    }

    function wireFolderToggleRows(assignedSet) {
        modalEl.querySelectorAll('[data-folder-toggle]').forEach(function (row) {
            row.addEventListener('click', function () {
                var fid = this.getAttribute('data-folder-toggle');
                var isOn = this.classList.contains('is-selected');
                if (isOn) {
                    window.dgFav.removeFromFolder(fid, modalHandle);
                    this.classList.remove('is-selected');
                    this.setAttribute('aria-checked', 'false');
                } else {
                    window.dgFav.addToFolder(fid, modalHandle);
                    this.classList.add('is-selected');
                    this.setAttribute('aria-checked', 'true');
                }
                var f = getFolderById(fid);
                if (f) {
                    var countEl = this.querySelector('.dg-fav-folder-row__count');
                    if (countEl) countEl.textContent = formatProductCount(f.handles.length);
                }
                var item = gridEl && gridEl.querySelector('.dg-fav-item[data-fav-key="' + cssEscape(modalHandle) + '"]');
                if (item) enrichCard(item);
                buildFolderFilters();
                applyFilters();
            });
        });
    }

    function wireCreateSection(opts) {
        opts = opts || {};
        var palette = window.dgFav.colors();
        var selectedColor = palette[0] || 'blue';
        var createWrap = modalEl.querySelector('#dg-fav-folder-create');
        var toggleBtn = modalEl.querySelector('[data-create-toggle]');
        var body = createWrap && createWrap.querySelector('.dg-fav-folder-create__body');
        var colorToggle = modalEl.querySelector('[data-color-toggle]');
        var colorPanel = modalEl.querySelector('[data-color-panel]');

        function setCreateExpanded(open) {
            if (!createWrap || !body || !toggleBtn) return;
            createWrap.classList.toggle('is-collapsed', !open);
            body.hidden = !open;
            toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        function setColorExpanded(open) {
            if (!colorPanel || !colorToggle) return;
            colorPanel.hidden = !open;
            colorToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            colorToggle.classList.toggle('is-open', open);
        }

        if (toggleBtn) {
            toggleBtn.addEventListener('click', function () {
                setCreateExpanded(createWrap.classList.contains('is-collapsed'));
            });
        }
        if (colorToggle) {
            colorToggle.addEventListener('click', function () {
                setColorExpanded(colorPanel.hidden);
            });
        }
        if (opts.expandCreate) setCreateExpanded(true);

        modalEl.querySelectorAll('[data-new-color]').forEach(function (sw) {
            sw.addEventListener('click', function () {
                modalEl.querySelectorAll('[data-new-color]').forEach(function (s) { s.classList.remove('is-active'); });
                this.classList.add('is-active');
                selectedColor = this.getAttribute('data-new-color');
            });
        });

        var createBtn = modalEl.querySelector('#dg-fav-create-and-assign');
        var nameInput = modalEl.querySelector('#dg-fav-new-folder-name');
        if (!createBtn || !nameInput) return;

        var handleCreate = function () {
            var n = (nameInput.value || '').trim();
            if (!n) {
                nameInput.focus();
                return;
            }
            var folder = window.dgFav.createFolder(n, selectedColor);
            if (!folder) {
                showToast('⚠️ Impossible de créer la liste (limite atteinte).');
                return;
            }
            if (modalMode === 'assign' && modalHandle) {
                window.dgFav.addToFolder(folder.id, modalHandle);
            }
            nameInput.value = '';
            showToast('📁 Liste « ' + n + ' » créée.');
            if (modalMode === 'create') {
                closeFolderModal();
                rebuildFolderFilters();
                return;
            }
            renderModal();
            buildFolderFilters();
            var item = gridEl && gridEl.querySelector('.dg-fav-item[data-fav-key="' + cssEscape(modalHandle) + '"]');
            if (item) enrichCard(item);
        };

        createBtn.addEventListener('click', handleCreate);
        nameInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleCreate();
            }
        });

        if (opts.focusName) {
            setCreateExpanded(true);
            setTimeout(function () { nameInput.focus(); }, 80);
        }
    }

    function saveManageFolderName() {
        if (modalMode !== 'manage' || !modalManageFolderId) return;
        var folder = getFolderById(modalManageFolderId);
        var input = modalEl.querySelector('#dg-fav-manage-name');
        if (!folder || !input) return;
        var newName = (input.value || '').trim();
        if (!newName || newName === folder.name) return;
        window.dgFav.renameFolder(folder.id, newName);
        rebuildFolderFilters();
    }

    function refreshAfterFolderMutation(handle) {
        rebuildFolderFilters();
        applyFilters();
        if (handle && gridEl) {
            var item = gridEl.querySelector('.dg-fav-item[data-fav-key="' + cssEscape(handle) + '"]');
            if (item) enrichCard(item);
        } else {
            enrichAllCards();
        }
    }

    function buildManageProductRowHTML(handle) {
        var preview = getProductPreview(handle);
        var title = preview.title || handle;
        return ''
            + '<li class="dg-modal__manage-product">'
            + (preview.imgSrc
                ? '<img class="dg-modal__manage-product-img" src="' + escapeHTML(preview.imgSrc) + '" alt="" width="40" height="40" loading="lazy">'
                : '<span class="dg-modal__manage-product-img dg-modal__manage-product-img--empty" aria-hidden="true"></span>')
            + '<span class="dg-modal__manage-product-title">' + escapeHTML(title) + '</span>'
            + '<button type="button" class="dg-modal__manage-product-remove" data-manage-remove="' + escapeHTML(handle) + '" aria-label="Retirer de la liste">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>'
            + '</button>'
            + '</li>';
    }

    function buildManageProductsBlockHTML(folder) {
        var loaded = getLoadedFavoriteHandlesSet();
        var handles = folder.handles.filter(function (h) { return loaded[h]; });
        var listHTML = '';
        if (!handles.length) {
            listHTML = '<p class="dg-modal__manage-products-empty">Aucun produit dans cette liste pour l\'instant.</p>';
        } else {
            listHTML = '<ul class="dg-modal__manage-product-list" role="list">';
            for (var i = 0; i < handles.length; i++) {
                listHTML += buildManageProductRowHTML(handles[i]);
            }
            listHTML += '</ul>';
        }
        var countLabel = formatProductCount(handles.length);
        return ''
            + '<div class="dg-modal__manage-products">'
            + '  <div class="dg-modal__manage-products-head">'
            + '    <h4 class="dg-modal__manage-products-title">Produits dans cette liste</h4>'
            + '    <span class="dg-modal__manage-products-count">' + escapeHTML(countLabel) + '</span>'
            + '  </div>'
            + listHTML
            + '  <button type="button" class="dg-btn dg-btn--primary dg-modal__manage-add-btn" data-manage-add-products>Ajouter des produits</button>'
            + '</div>';
    }

    function buildManageAddProductsBlockHTML(folder) {
        var inFolder = {};
        for (var i = 0; i < folder.handles.length; i++) inFolder[folder.handles[i]] = true;

        var loaded = getLoadedFavoriteHandlesSet();
        var available = [];
        var allHandles = window.dgFav.list();
        for (var j = 0; j < allHandles.length; j++) {
            var h = allHandles[j];
            if (!inFolder[h] && loaded[h]) available.push(h);
        }

        if (!available.length) {
            return ''
                + '<div class="dg-modal__manage-batch">'
                + '  <p class="dg-modal__manage-batch-empty">Tous vos favoris sont déjà dans cette liste.</p>'
                + '</div>';
        }

        var rows = '';
        for (var k = 0; k < available.length; k++) {
            var h = available[k];
            var preview = getProductPreview(h);
            var title = preview.title || h;
            var searchBlob = normalizeText(h + ' ' + title);
            rows += ''
                + '<label class="dg-modal__batch-row" data-batch-search="' + escapeHTML(searchBlob) + '">'
                + '<input type="checkbox" class="visually-hidden" data-batch-pick value="' + escapeHTML(h) + '">'
                + '<span class="dg-fav-folder-row__check" aria-hidden="true">' + MODAL_CHECK_SVG + '</span>'
                + (preview.imgSrc
                    ? '<img class="dg-modal__batch-row-img" src="' + escapeHTML(preview.imgSrc) + '" alt="" width="40" height="40" loading="lazy">'
                    : '<span class="dg-modal__batch-row-img dg-modal__batch-row-img--empty" aria-hidden="true"></span>')
                + '<span class="dg-modal__batch-row-title">' + escapeHTML(title) + '</span>'
                + '</label>';
        }

        return ''
            + '<div class="dg-modal__manage-batch">'
            + '  <p class="dg-modal__manage-batch-hint">Sélectionnez un ou plusieurs favoris à ajouter à « ' + escapeHTML(folder.name) + ' ».</p>'
            + '  <div class="dg-modal__batch-search" role="search">'
            + '    <label for="dg-fav-batch-search" class="visually-hidden">Rechercher dans vos favoris</label>'
            + '    <div class="dg-hdr__search dg-modal__batch-search-field">'
            + '      <input type="search" id="dg-fav-batch-search" class="dg-hdr__search-input" data-batch-search-input placeholder="Rechercher un produit…" autocomplete="off" enterkeyhint="search">'
            + '      <button type="button" class="dg-fav-search__clear" data-batch-search-clear hidden aria-label="Effacer la recherche">'
            + '        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>'
            + '      </button>'
            + '    </div>'
            + '  </div>'
            + '  <button type="button" class="dg-btn dg-btn--ghost dg-modal__batch-select-all" data-batch-select-all>Tout sélectionner</button>'
            + '  <p class="dg-modal__manage-batch-empty dg-modal__batch-no-results" data-batch-no-results hidden>Aucun favori ne correspond à votre recherche.</p>'
            + '  <div class="dg-modal__batch-list">' + rows + '</div>'
            + '</div>';
    }

    function getVisibleBatchRows() {
        if (!modalEl) return [];
        var out = [];
        modalEl.querySelectorAll('.dg-modal__batch-row').forEach(function (row) {
            if (!row.hidden) out.push(row);
        });
        return out;
    }

    function updateBatchSearchClear() {
        if (!modalEl) return;
        var clearBtn = modalEl.querySelector('[data-batch-search-clear]');
        var input = modalEl.querySelector('[data-batch-search-input]');
        if (!clearBtn) return;
        clearBtn.hidden = !(input && input.value.trim());
    }

    function applyBatchSearchFilter() {
        if (!modalEl) return;
        var q = normalizeText(batchSearchQuery);
        var rows = modalEl.querySelectorAll('.dg-modal__batch-row');
        var noResults = modalEl.querySelector('[data-batch-no-results]');
        var visible = 0;

        rows.forEach(function (row) {
            var blob = row.getAttribute('data-batch-search') || '';
            var match = !q || blob.indexOf(q) !== -1;
            row.hidden = !match;
            if (match) visible++;
        });

        if (noResults) noResults.hidden = visible > 0 || !q;
        updateBatchSelectAllLabel();
    }

    function updateBatchSelectAllLabel() {
        var btn = modalEl && modalEl.querySelector('[data-batch-select-all]');
        if (!btn) return;
        var visible = getVisibleBatchRows();
        if (!visible.length) {
            btn.disabled = true;
            return;
        }
        btn.disabled = false;
        var allOn = true;
        for (var i = 0; i < visible.length; i++) {
            var inp = visible[i].querySelector('[data-batch-pick]');
            if (inp && !inp.checked) { allOn = false; break; }
        }
        btn.textContent = allOn ? 'Tout désélectionner' : 'Tout sélectionner';
    }

    function updateBatchAddButtonLabel() {
        var btn = modalEl && modalEl.querySelector('[data-manage-batch-add]');
        if (!btn) return;
        var n = modalEl.querySelectorAll('[data-batch-pick]:checked').length;
        btn.disabled = n === 0;
        btn.textContent = n === 0
            ? 'Ajouter à la liste'
            : 'Ajouter ' + n + ' produit' + (n > 1 ? 's' : '') + ' à la liste';
    }

    function wireManageProducts() {
        var addBtn = modalEl.querySelector('[data-manage-add-products]');
        if (addBtn) {
            addBtn.addEventListener('click', function (e) {
                e.preventDefault();
                openManageAddProducts();
            });
        }

        modalEl.querySelectorAll('[data-manage-remove]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var handle = this.getAttribute('data-manage-remove');
                if (!handle || !modalManageFolderId) return;
                window.dgFav.removeFromFolder(modalManageFolderId, handle);
                showToast('Retiré de la liste.');
                renderModal();
                refreshAfterFolderMutation(handle);
            });
        });
    }

    function wireManageAddProducts() {
        var folder = getFolderById(modalManageFolderId);
        if (!folder) return;

        var backBtn = modalEl.querySelector('[data-manage-back]');
        if (backBtn) {
            backBtn.addEventListener('click', function (e) {
                e.preventDefault();
                backToManageFromAdd();
            });
        }

        var batchAddBtn = modalEl.querySelector('[data-manage-batch-add]');
        var searchInput = modalEl.querySelector('[data-batch-search-input]');
        var searchClear = modalEl.querySelector('[data-batch-search-clear]');
        var rows = modalEl.querySelectorAll('.dg-modal__batch-row');

        if (searchInput) {
            searchInput.addEventListener('input', function () {
                clearTimeout(batchSearchDebounce);
                batchSearchDebounce = setTimeout(function () {
                    batchSearchQuery = (searchInput.value || '').trim();
                    updateBatchSearchClear();
                    applyBatchSearchFilter();
                }, 150);
            });
        }

        if (searchClear) {
            searchClear.addEventListener('click', function () {
                batchSearchQuery = '';
                if (searchInput) searchInput.value = '';
                updateBatchSearchClear();
                applyBatchSearchFilter();
                if (searchInput) searchInput.focus();
            });
        }

        rows.forEach(function (row) {
            var input = row.querySelector('[data-batch-pick]');
            if (!input) return;
            input.addEventListener('change', function () {
                row.classList.toggle('is-selected', input.checked);
                updateBatchSelectAllLabel();
                updateBatchAddButtonLabel();
            });
        });

        var selectAllBtn = modalEl.querySelector('[data-batch-select-all]');
        if (selectAllBtn) {
            selectAllBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var visible = getVisibleBatchRows();
                var allOn = true;
                for (var i = 0; i < visible.length; i++) {
                    var inp = visible[i].querySelector('[data-batch-pick]');
                    if (inp && !inp.checked) { allOn = false; break; }
                }
                visible.forEach(function (row) {
                    var pick = row.querySelector('[data-batch-pick]');
                    if (!pick) return;
                    pick.checked = !allOn;
                    row.classList.toggle('is-selected', pick.checked);
                });
                updateBatchSelectAllLabel();
                updateBatchAddButtonLabel();
            });
        }

        if (batchAddBtn) {
            batchAddBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (!modalManageFolderId) return;
                var selected = [];
                modalEl.querySelectorAll('[data-batch-pick]:checked').forEach(function (inp) {
                    if (inp.value) selected.push(inp.value);
                });
                if (!selected.length) return;

                var added = 0;
                for (var j = 0; j < selected.length; j++) {
                    if (window.dgFav.addToFolder(modalManageFolderId, selected[j])) added++;
                }

                showToast(added
                    ? added + ' produit' + (added > 1 ? 's' : '') + ' ajouté' + (added > 1 ? 's' : '') + ' à la liste.'
                    : 'Aucun produit ajouté.');
                modalMode = 'manage';
                renderModal();
                refreshAfterFolderMutation();
            });
        }

        applyBatchSearchFilter();
        updateBatchAddButtonLabel();
    }

    function wireManageSection() {
        var folder = getFolderById(modalManageFolderId);
        if (!folder) return;
        wireManageProducts();
        var palette = window.dgFav.colors();
        var nameInput = modalEl.querySelector('#dg-fav-manage-name');
        var deleteBtn = modalEl.querySelector('[data-manage-delete]');
        var confirmWrap = modalEl.querySelector('[data-delete-confirm-wrap]');
        var confirmYes = modalEl.querySelector('[data-delete-confirm]');
        var confirmNo = modalEl.querySelector('[data-delete-cancel]');

        modalEl.querySelectorAll('[data-manage-color]').forEach(function (sw) {
            sw.addEventListener('click', function () {
                var color = this.getAttribute('data-manage-color');
                window.dgFav.setFolderColor(folder.id, color);
                modalEl.querySelectorAll('[data-manage-color]').forEach(function (s) { s.classList.remove('is-active'); });
                this.classList.add('is-active');
                rebuildFolderFilters();
            });
        });

        if (deleteBtn && confirmWrap) {
            deleteBtn.addEventListener('click', function () {
                confirmWrap.hidden = false;
                deleteBtn.hidden = true;
            });
        }
        if (confirmNo && confirmWrap && deleteBtn) {
            confirmNo.addEventListener('click', function () {
                confirmWrap.hidden = true;
                deleteBtn.hidden = false;
            });
        }
        if (confirmYes) {
            confirmYes.addEventListener('click', function () {
                window.dgFav.deleteFolder(folder.id);
                if (activeFolderId === folder.id) activeFolderId = 'all';
                showToast('🗑️ Liste supprimée.');
                closeFolderModal();
                rebuildFolderFilters();
            });
        }
    }

    function renderModal(opts) {
        if (!modalEl || !window.dgFav) return;
        opts = opts || {};
        if (modalMode === 'assign' && !modalHandle) return;
        if ((modalMode === 'manage' || modalMode === 'manage-add') && !modalManageFolderId) return;

        var folders = window.dgFav.folders();
        var palette = window.dgFav.colors();
        var swatchHTML = buildSwatchHTML(palette, palette[0] || 'blue', 'data-new-color');
        var scrollHTML = '';
        var title = '';
        var sub = '';

        if (modalMode === 'manage') {
            var mf = getFolderById(modalManageFolderId);
            if (!mf) return;
            title = 'Gérer la liste';
            sub = 'Gérez les produits, le nom et la couleur. Retirer un produit ici ne le supprime pas de vos favoris.';
            var manageSwatches = buildSwatchHTML(palette, mf.color, 'data-manage-color');
            scrollHTML = ''
                + buildManageProductsBlockHTML(mf)
                + '<div class="dg-modal__manage">'
                + '  <label class="dg-fav-folder-create__label" for="dg-fav-manage-name">Nom de la liste</label>'
                + '  <input type="text" id="dg-fav-manage-name" class="dg-modal__manage-input" maxlength="40" value="' + escapeHTML(mf.name) + '" autocomplete="off">'
                + '  <p class="dg-fav-folder-create__label dg-modal__manage-color-label">Couleur de la liste</p>'
                + '  <div class="dg-fav-color-swatches dg-fav-color-swatches--manage">' + manageSwatches + '</div>'
                + '  <button type="button" class="dg-btn dg-btn--ghost dg-modal__delete-btn" data-manage-delete>Supprimer cette liste</button>'
                + '  <div class="dg-modal__delete-confirm" data-delete-confirm-wrap hidden>'
                + '    <p>Supprimer la liste « ' + escapeHTML(mf.name) + ' » ? Les produits resteront dans vos favoris.</p>'
                + '    <div class="dg-modal__delete-confirm-actions">'
                + '      <button type="button" class="dg-btn dg-btn--ghost" data-delete-cancel>Annuler</button>'
                + '      <button type="button" class="dg-btn dg-btn--danger" data-delete-confirm>Oui, supprimer</button>'
                + '    </div>'
                + '  </div>'
                + '</div>';
        } else if (modalMode === 'manage-add') {
            var mfa = getFolderById(modalManageFolderId);
            if (!mfa) return;
            title = 'Ajouter des produits';
            sub = 'Liste « ' + mfa.name + ' » — sélection multiple depuis vos favoris.';
            scrollHTML = buildManageAddProductsBlockHTML(mfa);
        } else if (modalMode === 'create') {
            title = 'Créer une liste';
            sub = 'Organisez vos produits favoris par thème ou par projet.';
            scrollHTML = buildCreateBlockHTML(swatchHTML, true, true);
        } else {
            var preview = getProductPreview(modalHandle);
            var assigned = window.dgFav.foldersOf(modalHandle);
            var assignedSet = {};
            for (var a = 0; a < assigned.length; a++) assignedSet[assigned[a]] = true;

            title = 'Ajouter à une liste';
            sub = 'Choisissez une ou plusieurs listes. Le produit reste dans vos favoris.';

            var previewHTML = '';
            if (preview.title || preview.imgSrc) {
                previewHTML = '<div class="dg-modal__product">'
                    + (preview.imgSrc
                        ? '<img class="dg-modal__product-img" src="' + escapeHTML(preview.imgSrc) + '" alt="' + escapeHTML(preview.imgAlt || preview.title) + '" width="48" height="48" loading="lazy">'
                        : '')
                    + '<p class="dg-modal__product-title">' + escapeHTML(preview.title || 'Produit') + '</p>'
                    + '</div>';
            }

            var listHTML = '';
            if (folders.length === 0) {
                listHTML = ''
                    + '<div class="dg-modal__empty-state">'
                    + '  <p class="dg-modal__empty-state-text">Vous n\'avez pas encore de liste. Créez-en une pour retrouver vos produits plus vite.</p>'
                    + '  <button type="button" class="dg-btn dg-btn--primary" data-empty-create-cta>Créer ma première liste</button>'
                    + '</div>';
            } else {
                for (var i = 0; i < folders.length; i++) {
                    var f = folders[i];
                    var isSel = !!assignedSet[f.id];
                    var countLabel = formatProductCount(f.handles.length);
                    listHTML += ''
                        + '<button type="button" class="dg-fav-folder-row dg-fav-color-' + escapeHTML(f.color)
                        + (isSel ? ' is-selected' : '') + '" data-folder-toggle="' + escapeHTML(f.id) + '"'
                        + ' role="checkbox" aria-checked="' + (isSel ? 'true' : 'false') + '"'
                        + ' aria-label="' + escapeHTML(f.name) + ', ' + escapeHTML(countLabel)
                        + (isSel ? ', sélectionnée' : '') + '">'
                        + '<span class="dg-fav-folder-row__check" aria-hidden="true">' + MODAL_CHECK_SVG + '</span>'
                        + '<span class="dg-fav-folder-row__dot"></span>'
                        + '<span class="dg-fav-folder-row__name">' + escapeHTML(f.name) + '</span>'
                        + '<span class="dg-fav-folder-row__count">' + escapeHTML(countLabel) + '</span>'
                        + '</button>';
                }
            }

            scrollHTML = previewHTML
                + '<div class="dg-fav-folder-list">' + listHTML + '</div>'
                + buildCreateBlockHTML(swatchHTML, !!opts.expandCreate);
        }

        var footerHTML = '';
        var footerBlock = '';
        if (modalMode === 'manage-add') {
            footerHTML = ''
                + '<button type="button" class="dg-btn dg-btn--ghost dg-modal__back" data-manage-back>Retour</button>'
                + '<button type="button" class="dg-btn dg-btn--primary dg-modal__batch-add" data-manage-batch-add disabled>Ajouter à la liste</button>';
            footerBlock = '<div class="dg-modal__footer dg-modal__footer--split">' + footerHTML + '</div>';
        } else if (modalMode !== 'create') {
            footerHTML = '<button type="button" class="dg-btn dg-btn--primary dg-modal__done" data-modal-close>Terminé</button>';
            footerBlock = '<div class="dg-modal__footer">' + footerHTML + '</div>';
        }

        modalEl.innerHTML = ''
            + '<div class="dg-modal__overlay" data-modal-close></div>'
            + '<div class="dg-modal__panel' + (modalMode === 'create' ? ' dg-modal__panel--no-footer' : '') + '" role="document">'
            + '  <div class="dg-modal__handle" aria-hidden="true"></div>'
            + '  <button type="button" class="dg-modal__close" aria-label="Fermer" data-modal-close>×</button>'
            + '  <div class="dg-modal__scroll">'
            + '    <h3 id="dg-fav-folder-modal-title" class="dg-modal__title">' + escapeHTML(title) + '</h3>'
            + '    <p class="dg-modal__sub">' + escapeHTML(sub) + '</p>'
            + scrollHTML
            + '  </div>'
            + footerBlock
            + '</div>';

        wireModalClose();

        if (modalMode === 'assign') {
            wireFolderToggleRows();
            wireCreateSection({ expandCreate: !!opts.expandCreate, focusName: !!opts.focusName });
            var emptyCta = modalEl.querySelector('[data-empty-create-cta]');
            if (emptyCta) {
                emptyCta.addEventListener('click', function () {
                    var createWrap = modalEl.querySelector('#dg-fav-folder-create');
                    var body = createWrap && createWrap.querySelector('.dg-fav-folder-create__body');
                    var toggleBtn = modalEl.querySelector('[data-create-toggle]');
                    var nameInput = modalEl.querySelector('#dg-fav-new-folder-name');
                    if (createWrap && body && toggleBtn) {
                        createWrap.classList.remove('is-collapsed');
                        body.hidden = false;
                        toggleBtn.setAttribute('aria-expanded', 'true');
                    }
                    if (nameInput) setTimeout(function () { nameInput.focus(); }, 80);
                });
            }
        } else if (modalMode === 'create') {
            wireCreateSection({ expandCreate: true, focusName: true });
        } else if (modalMode === 'manage') {
            wireManageSection();
        } else if (modalMode === 'manage-add') {
            wireManageAddProducts();
        }
    }

    function cssEscape(s) {
        if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
        return String(s).replace(/[^a-zA-Z0-9_-]/g, function (c) { return '\\' + c; });
    }

    /* ══════════════════════════════════════════════════════════
       RENDER — fetch and display favorites
       ══════════════════════════════════════════════════════════ */
    function renderFavorites() {
        if (!window.dgFav) {
            console.warn('[dg-favorites] dgFav API not available');
            if (loadingEl) loadingEl.remove();
            checkEmpty();
            return;
        }

        var handles = window.dgFav.list();

        if (!handles.length) {
            if (loadingEl) loadingEl.remove();
            buildFolderFilters();
            checkEmpty();
            return;
        }

        if (gridEl) {
            gridEl.querySelectorAll('.dg-fav-item').forEach(function (el) { el.remove(); });
            // La grille redevient celle des favoris : purger tout reliquat du mode
            // historique, même si on n'est pas passé par sortirHistorique().
            gridEl.classList.remove('is-historique');
            var reste = gridEl.parentNode && gridEl.parentNode.querySelector('.dg-fav-hist-more');
            if (reste) reste.remove();
            gridEl.style.display = '';
        }

        pool(handles, FETCH_CONCURRENCY, fetchProductHTMLWithRetry).then(function (results) {
            if (loadingEl) loadingEl.remove();
            pruneStaleFavoriteHandles(handles, results);

            var valid = [];
            var failed = 0;
            for (var i = 0; i < results.length; i++) {
                if (results[i] && results[i].status === 'ok') valid.push(results[i].html);
                else if (!results[i] || results[i].status === 'error') failed++;
            }
            // Showing a shorter list without saying why reads as "my favorites vanished".
            if (failed > 0) {
                showToast(failed + (failed > 1 ? ' favoris n’ont pas pu être affichés.' : ' favori n’a pas pu être affiché.') + ' Rafraîchissez la page.');
            }

            if (!valid.length) {
                buildFolderFilters();
                checkEmpty();
                return;
            }

            if (gridEl) {
                gridEl.innerHTML = valid.join('');
                gridEl.style.display = '';
            }

            enrichAllCards();
            buildFolderFilters();
            buildTypeFilters();
            applyFilters();

            if (typeof window.refreshCartState === 'function') window.refreshCartState();

        }).catch(function () {
            if (loadingEl) loadingEl.remove();
            buildFolderFilters();
            checkEmpty();
        });
    }

    /* ══════════════════════════════════════════════════════════
       HISTORIQUE D'ACHATS — rendu de la liste auto
       ══════════════════════════════════════════════════════════ */

    var MOIS_FR = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

    function dateFr(iso) {
        var d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        return d.getDate() + ' ' + MOIS_FR[d.getMonth()] + ' ' + d.getFullYear();
    }

    function histItemsTries() {
        var items = (histData && histData.items ? histData.items : []).slice();
        if (histSort === 'frequence') {
            // À fréquence égale, le plus récent d'abord : deux produits commandés
            // 3 fois ne sont pas interchangeables pour qui refait sa commande.
            items.sort(function (a, b) {
                return (b.fois - a.fois) || (a.derniere < b.derniere ? 1 : -1);
            });
        } else if (histSort === 'alpha') {
            items.sort(function (a, b) {
                return String(a.title || '').localeCompare(String(b.title || ''), 'fr');
            });
        } else {
            items.sort(function (a, b) { return a.derniere < b.derniere ? 1 : -1; });
        }
        return items;
    }

    function histSortLabel() {
        if (histSort === 'frequence') return 'Le plus souvent commandé';
        if (histSort === 'alpha') return 'Ordre alphabétique';
        return 'Commandé récemment';
    }

    /** Puce de tri, visible en mode historique seulement. */
    function buildHistSort() {
        var slot = document.getElementById('dg-fav-hist-sort-slot');
        if (!slot) return;
        if (!isHistMode()) {
            slot.hidden = true;
            slot.innerHTML = '';
            return;
        }
        var opts = [
            ['recence', 'Commandé récemment'],
            ['frequence', 'Le plus souvent commandé'],
            ['alpha', 'Ordre alphabétique']
        ];
        var menu = '';
        for (var i = 0; i < opts.length; i++) {
            menu += '<button type="button" class="dg-fav-filter-option' + (histSort === opts[i][0] ? ' is-active' : '') + '" data-hist-sort="' + opts[i][0] + '">'
                + '<span class="dg-fav-filter-option__dot"></span>'
                + '<span class="dg-fav-filter-option__name">' + escapeHTML(opts[i][1]) + '</span>'
                + '</button>';
        }
        slot.innerHTML = buildFilterDropdownMarkup(histSortLabel(), histSort !== 'recence', menu);
        slot.hidden = false;
    }

    /** Bandeau explicatif : dire la profondeur réelle plutôt que la laisser devinée. */
    function updateHistNote() {
        var noteEl = document.getElementById('dg-fav-hist-note');
        if (!noteEl) return;
        if (!isHistMode() || !histData) {
            noteEl.hidden = true;
            noteEl.textContent = '';
            return;
        }
        var txt = 'Liste automatique : vos achats des ' + (histData.fenetreMois || 6) + ' derniers mois. '
            + 'Vous ne pouvez pas la modifier — touchez le cœur pour épingler un produit dans vos favoris.';
        // La couverture réelle est plus courte que la fenêtre demandée tant que le
        // miroir des commandes n'a pas 6 mois d'âge. Le taire ferait lire « il
        // manque des choses » comme un bogue.
        var cov = histData.couvertureShopifyDepuis;
        if (cov && histData.depuis && cov > histData.depuis) {
            txt += ' Nos commandes en ligne sont enregistrées depuis le ' + dateFr(cov) + '.';
        }
        noteEl.textContent = txt;
        noteEl.hidden = false;
    }

    /** Ligne « Dernière commande : … · N fois » ajoutée sous chaque carte. */
    function enrichHistCard(item, entry) {
        if (!item || !entry) return;
        item.setAttribute('data-hist-date', entry.derniere || '');
        item.setAttribute('data-hist-fois', String(entry.fois || 0));
        item.setAttribute('data-hist-sources', (entry.sources || []).join(','));
        if (entry.indisponible) item.classList.add('is-unavailable');

        if (item.querySelector('.dg-fav-item__hist')) return;
        var p = document.createElement('p');
        p.className = 'dg-fav-item__hist';
        var bits = ['Dernière commande : ' + dateFr(entry.derniere)];
        if (entry.fois > 1) bits.push(entry.fois + ' fois');
        p.textContent = bits.join(' · ');
        var card = item.querySelector('.dg-product-card');
        if (card && card.parentNode) card.parentNode.insertBefore(p, card.nextSibling);
        else item.appendChild(p);
    }

    function histVoirPlusBouton(restant) {
        var old = gridEl.parentNode.querySelector('.dg-fav-hist-more');
        if (old) old.remove();
        if (restant <= 0) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dg-fav-hist-more';
        btn.textContent = 'Voir plus (' + restant + ' restant' + (restant > 1 ? 's' : '') + ')';
        btn.addEventListener('click', function () {
            btn.disabled = true;
            btn.textContent = 'Chargement…';
            renderHistorique(true);
        });
        gridEl.parentNode.insertBefore(btn, gridEl.nextSibling);
    }

    /**
     * Rend l'historique dans la même grille que les favoris, par tranches.
     *
     * Réutilise EXACTEMENT le chemin de rendu des favoris (section
     * `dg-ajax-favorite-card` par variante) : on récupère ainsi le prix contextuel
     * B2B, le quick-add et le cœur sans écrire une ligne de logique de prix.
     *
     * @param {boolean} suite  true = ajouter la tranche suivante, false = repartir de zéro.
     */
    function renderHistorique(suite) {
        if (!gridEl || !window.dgFav || !window.dgFav.historique) return;
        if (histLoading) return;
        histLoading = true;

        if (!suite) {
            histShown = 0;
            gridEl.querySelectorAll('.dg-fav-item').forEach(function (el) { el.remove(); });
            var more = gridEl.parentNode.querySelector('.dg-fav-hist-more');
            if (more) more.remove();
            gridEl.classList.add('is-historique');
            if (loadingEl) loadingEl.hidden = false;
        }

        window.dgFav.historique().then(function (data) {
            if (data) histData = data;
            if (loadingEl) loadingEl.hidden = true;

            var tries = histItemsTries();
            var tranche = tries.slice(histShown, histShown + HIST_PAGE);
            if (!tranche.length) {
                histLoading = false;
                buildFolderFilters();
                buildHistSort();
                updateHistNote();
                checkEmpty();
                return;
            }

            var parCle = {};
            for (var i = 0; i < tranche.length; i++) parCle[tranche[i].itemKey] = tranche[i];
            var cles = tranche.map(function (e) { return e.itemKey; });

            // ⚠️ On n'appelle JAMAIS pruneStaleFavoriteHandles ici. Elle est câblée
            // sur la liste des vrais favoris : lui passer des clés d'historique
            // supprimerait des favoris légitimes, côté serveur y compris.
            pool(cles, FETCH_CONCURRENCY, fetchProductHTMLWithRetry).then(function (results) {
                var ajoutes = 0;
                for (var j = 0; j < results.length; j++) {
                    var r = results[j];
                    if (!r || r.status !== 'ok') continue;
                    var wrap = document.createElement('div');
                    wrap.innerHTML = r.html;
                    var el = wrap.querySelector('.dg-fav-item');
                    if (!el) continue;
                    gridEl.appendChild(el);
                    enrichCard(el);
                    enrichHistCard(el, parCle[el.getAttribute('data-fav-key')]);
                    ajoutes++;
                }
                histShown += tranche.length;
                gridEl.style.display = '';

                buildFolderFilters();
                buildTypeFilters();
                buildHistSort();
                updateHistNote();
                applyFilters();
                histVoirPlusBouton(tries.length - histShown);

                if (typeof window.refreshCartState === 'function') window.refreshCartState();
                if (ajoutes === 0 && tranche.length > 0) {
                    showToast('Ces produits n’ont pas pu être affichés. Rafraîchissez la page.');
                }
                histLoading = false;
            }).catch(function () {
                histLoading = false;
                if (loadingEl) loadingEl.hidden = true;
                checkEmpty();
            });
        }).catch(function () {
            histLoading = false;
            if (loadingEl) loadingEl.hidden = true;
            showToast('Impossible de charger votre historique d’achats.');
            checkEmpty();
        });
    }

    /**
     * Charge l'historique en arrière-plan au démarrage, sans rien afficher.
     *
     * Sans ça, la puce « Déjà commandé » n'apparaîtrait jamais : personne ne
     * pense à cliquer sur une liste dont il ignore l'existence. Une seule requête,
     * agrégée côté worker — pas de cartes rendues tant qu'on n'entre pas dans le mode.
     */
    function precargerHistorique() {
        if (!window.dgFav || !window.dgFav.historique) return;
        window.dgFav.historique().then(function (data) {
            if (!data || !data.items || !data.items.length) return;
            histData = data;
            // Ne rien redessiner de la grille : on ajoute seulement l'entrée au menu.
            buildFolderFilters();
        }).catch(function () { /* l'absence d'historique n'est pas une panne */ });
    }

    /** Quitte le mode historique et revient aux vrais favoris. */
    function sortirHistorique() {
        gridEl.classList.remove('is-historique');
        var more = gridEl.parentNode.querySelector('.dg-fav-hist-more');
        if (more) more.remove();
        histShown = 0;
        buildHistSort();
        updateHistNote();
        renderFavorites();
    }

    function updateSyncBanner() {
        if (!syncBannerEl || !window.dgFav || !window.dgFav.getSyncStatus) return;

        var status = window.dgFav.getSyncStatus();

        if (status === 'guest') {
            syncBannerEl.hidden = false;
            syncBannerEl.className = 'dg-fav-sync-banner dg-fav-sync-banner--guest';
            syncBannerEl.innerHTML = ''
                + '<span>Connectez-vous pour retrouver vos favoris sur tous vos appareils.</span>'
                + '<a href="' + escapeHTML(loginUrl) + '" class="dg-fav-sync-banner__link">Se connecter</a>';
            return;
        }

        if (status === 'error') {
            syncBannerEl.hidden = false;
            syncBannerEl.className = 'dg-fav-sync-banner dg-fav-sync-banner--error';
            syncBannerEl.innerHTML = ''
                + '<span>Impossible de synchroniser vos favoris pour le moment.</span>'
                + '<button type="button" class="dg-fav-sync-banner__link" id="dg-fav-sync-retry">Réessayer</button>';
            var retryBtn = document.getElementById('dg-fav-sync-retry');
            if (retryBtn) {
                retryBtn.addEventListener('click', function () {
                    bootFavoritesPage(true);
                }, { once: true });
            }
            return;
        }

        if (status === 'pending') {
            syncBannerEl.hidden = false;
            syncBannerEl.className = 'dg-fav-sync-banner dg-fav-sync-banner--pending';
            syncBannerEl.textContent = 'Synchronisation de vos favoris…';
            return;
        }

        syncBannerEl.hidden = true;
        syncBannerEl.textContent = '';
    }

    function bootFavoritesPage(forceResync) {
        updateSyncBanner();

        var boot = function () {
            renderFavorites();
            updateSyncBanner();
            precargerHistorique();
        };

        if (window.dgFav && window.dgFav.isSyncEnabled()) {
            var p = forceResync ? window.dgFav.syncFromServer() : window.dgFav.syncFromServer();
            return p.then(boot).catch(boot);
        }

        boot();
        return Promise.resolve();
    }

    /* ══════════════════════════════════════════════════════════
       INIT
       ══════════════════════════════════════════════════════════ */
    document.addEventListener('DOMContentLoaded', function () {
        if (addAllBtn) {
            addAllBtn.addEventListener('click', function () {
                window.dgFavAddAll();
            });
        }

        if (searchInput) {
            searchInput.addEventListener('input', function () {
                clearTimeout(searchDebounce);
                searchDebounce = setTimeout(function () {
                    searchQuery = (searchInput.value || '').trim();
                    updateSearchClear();
                    applyFilters();
                }, 200);
            });
        }

        if (searchClearBtn) {
            searchClearBtn.addEventListener('click', function () {
                searchQuery = '';
                if (searchInput) searchInput.value = '';
                updateSearchClear();
                applyFilters();
                if (searchInput) searchInput.focus();
            });
        }

        if (resetBtn) {
            resetBtn.addEventListener('click', resetFilters);
        }

        initFavFilterDropdowns();
        bootFavoritesPage(false);

        if (window.dgFav) {
            window.dgFav.onChange(function (handles) {
                // En mode historique, la grille ne reflète PAS la liste des favoris :
                // comparer les deux comptes déclencherait renderFavorites() au
                // premier clic sur un cœur, et l'écran sauterait de l'historique aux
                // favoris sous le doigt du client. On se contente de rafraîchir les
                // compteurs du menu.
                if (isHistMode()) {
                    buildFolderFilters();
                    return;
                }
                var domCount = gridEl ? gridEl.querySelectorAll('.dg-fav-item').length : 0;
                var listCount = handles ? handles.length : window.dgFav.list().length;
                if (listCount !== domCount) {
                    renderFavorites();
                } else {
                    rebuildFolderFilters();
                }
            });

            if (window.dgFav.onSyncStatus) {
                window.dgFav.onSyncStatus(function () {
                    updateSyncBanner();
                });
            }
        }

        window.addEventListener('pageshow', function (e) {
            if (e.persisted && window.dgFav && window.dgFav.isSyncEnabled()) {
                bootFavoritesPage(true);
            }
        });

        // Esc closes modal or remove confirmation
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            if (activeRemoveConfirmItem) {
                closeRemoveConfirm(activeRemoveConfirmItem);
                return;
            }
            if (modalEl && !modalEl.hidden) {
                if (modalMode === 'manage-add') {
                    backToManageFromAdd();
                    return;
                }
                closeFolderModal();
            }
        });

        document.addEventListener('click', function (e) {
            if (!activeRemoveConfirmItem) return;
            if (activeRemoveConfirmItem.contains(e.target)) return;
            closeRemoveConfirm(activeRemoveConfirmItem);
        });
    });

})();
